import { Box, Typography } from '@mui/material';
import React from 'react';
import { Event } from '../../../types/Event';
import AppLink from '../../common/AppLink/AppLink';
import { ROUTE_PATHS } from '../../../routes/Routes';
import {
  tileContainerStyles,
  tileHeaderSectionStyles,
  textContainerStyles,
  textContainerSecondaryStyles,
  tileSectionLeftStyles,
  secondaryLabelStyles,
  secondaryTextStyles,
  secondaryIconStyles,
  tileHeaderLeftStyles,
} from '../dashboardStyles';
import { humanizeEventDateTimes } from '../../../utility/dateUtils';
import { AccountBalanceOutlined, CalendarMonthOutlined } from '@mui/icons-material';

export function EventTile(event: Event) {
  console.log(event);
  return (
    <Box key={event.uuid} sx={tileContainerStyles}>
      <Box sx={tileSectionLeftStyles}>
        <Box sx={tileHeaderSectionStyles}>
          <AppLink to={`/${ROUTE_PATHS.EVENTS}/${event.uuid}`} sx={textContainerStyles}>
            <Typography title={event.name} sx={tileHeaderLeftStyles}>
              {event.name}
            </Typography>
          </AppLink>
        </Box>
        <Box sx={textContainerSecondaryStyles}>
          <Box sx={secondaryTextStyles}>
            <CalendarMonthOutlined sx={secondaryIconStyles} />
            <Typography sx={secondaryLabelStyles}>{humanizeEventDateTimes(event)}</Typography>
          </Box>
          <Box sx={secondaryTextStyles}>
            <AccountBalanceOutlined sx={secondaryIconStyles} />
            <AppLink to={`/${ROUTE_PATHS.ACCOUNTS}/${event.account_uuid}`} sx={textContainerSecondaryStyles}>
              <Typography sx={secondaryLabelStyles}>{event.account_display_name}</Typography>
            </AppLink>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
